<template>
  <div>
    <cookie-consent>
      <template slot="message">
        We use cookies to ensure we give you the best experience on our website. Are you happy for us to use cookies 
      </template>
      <template slot="button">
        <button class="btn btn-info" style="margin-right: 10px; margin-left: 10px;">Yes</button>
        <button class="btn btn-info">No</button>
        <a style="color: #fff" class="btn btn-link" href="https://travel.flightsite.co.za/privacy-policy/#cookies">Cookie Policy</a>
      </template>
    </cookie-consent>
    <div class="top_nav">
      <a href="/" target="_self" class="top_nav">Flights</a>
      <a href="https://bus.flightsite.co.za/" target="_self" class="top_nav">Busses</a>
      <a href="https://holidays.flightsite.co.za/travel-packages/" class="top_nav" target="_self">Packages</a>
      <a href="https://www.travelstart.co.za/accommodation/?language=en&currency=ZAR" class="top_nav" target="_self">Accommodation</a>
      <!-- <a href="https://flightsite.hejju.com/" class="top_nav" target="_self">Activities</a>
      <a
        href="https://travelinsurance.brytesa.com/direct?organisationcode=flightsite&nisorganisationcode=SAP-1107718"
        class="top_nav"
        target="_blank"
        >Insurance</a> -->
      <a href="https://blog.flightsite.co.za/" target="_blank" class="top_nav"
        >Blog</a
      >
      <a
        href="https://travel.flightsite.co.za/travel/contact-us/"
        target="_self"
        class="top_nav"
        >Contact</a
      >
      <div class="top_nav__social_icons">
        <a
          href="https://www.instagram.com/flightsite/"
          style="color: #fff; padding: 10px 7px; background:none; border: none;"
          target="_blank"
          ><i class="fa fa-lg fa-instagram" aria-hidden="true"></i
        ></a>
        <a
          href="https://www.facebook.com/Flightsite"
          style="color: #fff; padding: 10px 7px; background:none; border: none;"
          target="_blank"
          ><i class="fa fa-lg fa-facebook" aria-hidden="true"></i
        ></a>
        <a
          href="https://twitter.com/flightsite"
          style="color: #fff; padding: 10px 0 10px 7px; background:none; border: none; margin-right: 10px;"
          target="_blank"
          ><i class="fa fa-lg fa-twitter" aria-hidden="true"></i
        ></a>
      </div>
    </div>

    <nav
      class="navbar"
      style="background: #fff; display: flex; flex-wrap: wrap; justify-content: flex-start;"
    >
      <div class="col-md-3 nav_logo_container">
        <a class="navbar-brand" href="/" target="_self">
          <img
            class="header-image"
            src="@/assets/images/flightsite_logo.png"
            alt="Book Flights Online"
          />
        </a>
      </div>

      <div class="nav_details_container desktop_only">
        <div class="nav_details_container_inner">
          <div>
            <p style="margin: 0;">
              <i class="fa fa-phone" aria-hidden="true"></i> 0860 23 24 25
            </p>
            <p>
              <i class="fa fa-envelope envelope-icon" aria-hidden="true"></i>
              <b
                ><a class="nav-mail" href="mailto:info@flightsite.co.za?subject=Website Enquiry">
                  info@flightsite.co.za
                </a></b
              >
            </p>
          </div>
        </div>
        <div style="display: flex;margin-left: 15px; margin-right: 5px;">
          <img
            alt="World Travel Awards - Winner 2017"
            src="@/assets/images/africas-leading-online-travel-agency-2017-winner-shield-64.png"
            vspace="10"
          />
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "FlightsiteNav"
};
</script>

<style lang="scss" scoped>

$cookieconstent-background: #0977b9;
@import "@/assets/styles/settings.scss";
@import "./node_modules/vue-cookieconsent-component/src/scss/cookie-consent";
@import "./node_modules/vue-cookieconsent-component/src/scss/cookie-consent-bottom";
@import "./node_modules/vue-cookieconsent-component/src/scss/cookie-consent-transition";

.navbar {
  margin-bottom: 0;
  border-bottom: 2px solid #0977b9;
  z-index: 0;
}

.cookie-consent, .cookie-consent a:link {
  color: #fff;
}
.cookie-consent a:link {
  text-decoration: underline;
}

.top_nav {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.header-image {
  height: 60px;
}

.nav_details_container {
  display: flex;
  margin-left: auto;
  margin-right: 20px;
}

.nav_details_container_inner {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: right;
}

.top_nav__social_icons {
  padding: 0px 0px 8px 0px;
}

.nav-mail {
  color: #959595;
    text-decoration: none;
    font-weight: 700;
    line-height: 1.429;
    margin-left: 5px;
}

  .top_nav {
    background-color: #0977b9;
    padding: 12px 0px;
    text-align: center;
  }
  .top_nav:link, .top_nav:visited {
    margin: 0px 10px;
    color: #fff;
    text-transform: uppercase;
    font-size: 12px;
    letter-spacing: 2px; 
  }

.reference-bar {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: flex-end;
  max-width: 1080px;
  margin: auto;
  flex-wrap: wrap;
}

.home-icon {
  text-align: center;
  padding-top: 20px;
  width: 100%;
}

@media (min-width: 781px) {
  .home-icon {
    width: unset;
  }
}

@media (max-width: 570px) {
  .navbar {
    flex-direction: column;
  }

  .nav_details_container {
    display: flex;
    margin: auto;
    margin-top: 20px;
    flex-direction: row-reverse;
  }

  .nav_details_container_inner {
    text-align: left;
    margin-top: 0;
    margin-left: 20px;
  }

  .nav_details_container_inner>div>p {
    margin-left: 0;
  }

  .envelope-icon {
    margin-left: 0;
  }

  .nav_pnp_logo {
    display: none;
  }

  .nav_logo_container {
    margin: auto;
  }
}
</style>
